export default {
      id: "social-03-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#social-03",
      toString: function () {
        return this.url;
      }
    }